module.exports = __webpack_public_path__ + "img/KOSCA_SNB.12e881fa.svg";